import React, { useState } from "react";
import {Modal, ModalHeader, ModalBody} from "../../components/Modal";
import iconDown from "url:shared-assets/icons/chevronDown.svg";
import ResultInfoModalExpant from "./components/ResultInfoModalExpant";
import { useTranslation } from "react-i18next";

interface Props {
  close: () => void;
}

const ResultInfoModal = (props: Props) => {
   const [open, setOpen] = useState(0);
   const translation = useTranslation();
    const { t, i18n } = translation;
  const resultModelData = [
    {
      id: 1,
      title: t("self-assessment-and-feedback-title"),
      component: <ResultInfoModalExpant id={1} />,
    },
    {
      id: 2,
      title: t("perception-gap-title"),
      component: <ResultInfoModalExpant id={2} />,
    },
     {
      id: 3,
      title: t("feedback-alignment-title"),
      component: <ResultInfoModalExpant id={3} />,
    },
    {
      id: 4,
      title: t("focus-area-health-title"),
      component: <ResultInfoModalExpant id={4} />,
    },
    {
      id: 5,
      title: t("assessment-question-interpretation-title"),
      component: <ResultInfoModalExpant id={5} />,
    },
  ];
  return (
    <Modal isOpen={true} onClose={props.close}>
      <ModalHeader onClose={props.close}>{t("report-info-model-title")}</ModalHeader>
      <ModalBody>
        {resultModelData.map((item) => (
          <div key={item.id} className="rounded-[6px] border border-indigo-700 p-4 gap-3 mb-4 cursor-pointer"
               onClick={() => setOpen(open === item.id ? 0 : item.id)}>
            <div className="flex justify-between" style={{ alignItems: "center" }}>
              <div className="z-title3 gray-100">
                {item.title}
              </div>
              <img src={iconDown} alt="toggle"
                   className={"h-4 w-4 cursor-pointer hover:bg-indigo-700 rounded-[12px]" + (open === item.id ? " rotate-180" : "")}
                   />
            </div>
            {open === item.id && (
              <div className="mt-2 gray-100">
                {item.component}
              </div>
            )}
          </div>
        ))}
      </ModalBody>
    </Modal>
  );
};

export default ResultInfoModal;
